import { render, staticRenderFns } from "./creer-patient-modal.html?vue&type=template&id=3c5ec023&scoped=true&external"
import script from "./creer-patient-modal.js?vue&type=script&lang=js&external"
export * from "./creer-patient-modal.js?vue&type=script&lang=js&external"
import style0 from "./creer-patient-modal.scss?vue&type=style&index=0&id=3c5ec023&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ec023",
  null
  
)

export default component.exports